import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import axios from 'axios';
import InputMask from "react-input-mask";
import constants from './helpers/Constants';
import './App.css';

function Cadastro() {

    const [cpf, setCPF] = useState('');

    const [showMsg, setShowMsg] = useState(false);
    const [msg, setMsg] = useState('');
    const toggleMsg = () => setShowMsg(!showMsg);

    const history = useHistory();

    const handleContinuar = () => {

        axios({
            method: 'post',
            url: constants.APIURLGet,
            headers: {
              'APITOKEN': constants.APIToken
            },
            data: {
              query: `select * from associado where cpf = '${cpf}'`
            }
        })
        .then(function (response) {
            if(response.data.length === 0){
                setMsg('O CPF informado não foi encontrado em nosso banco de dados. Entre em contato com a Federação para solicitar seu pré-cadastro.');
                setShowMsg(true);
            }
            else{
                let associado = response.data[0];
                if(associado.ativo === "1"){
                    setMsg('O CPF informado já tem um cadastro ativo. Faça login para acessar.');
                    setShowMsg(true);
                }
                else{
                    sessionStorage.setItem("cpfCadastro", cpf);
                    history.push("/cadastro2");
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    };


    return (
        <Container>
            <Modal isOpen={showMsg}>
                <ModalBody>
                    {msg}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggleMsg}>OK</Button>{' '}
                </ModalFooter>
            </Modal>
            <Row>
                <Col className="bg-azul text-center pt-3">
                    <img src="logo.png" alt="Logo FIKM" style={{'width': '40%'}}></img>
                </Col>
            </Row>
            <Row>
                <Col className="bg-azul h5 text-white pt-3 pb-5 text-center mb-5" style={{'borderRadius': '0px 0px 30px 30px'}}>
                    Cadastro de Associado
                </Col>
            </Row>
            <Row>
                <Col>
                    <InputMask mask="999.999.999-99" value={cpf} onChange={(e) => setCPF(e.target.value)} className="form-control text-center" placeholder="CPF"></InputMask>
                </Col>
            </Row>
            <Row>
                <Col className="mt-3">
                    <Button onClick={handleContinuar} className="btn btn-block btn-lg btn-primary btn-azul">CONTINUAR</Button>
                </Col>
            </Row>
            <Row>
                <Col className="mt-2">
                    <Button href="/" className="btn btn-block btn-lg btn-outline-primary btn-outline-azul">VOLTAR</Button>
                </Col>
            </Row>
        </Container>
    );
}

export default Cadastro;
